var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OtherPageLayout',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm._f("lang")('Preguntas frecuentes'))+" ")]},proxy:true}])},[_c('ExpansionPanels',{staticClass:"mt-4",attrs:{"items":[
			{
				header: _vm.$lang('¿Cómo hago mi libro personalizado?'),
				content: _vm.$langText(
					'Es muy fácil: selecciona el libro que quieres regalar, completa los datos que te pedimos en el formulario de personalización, los de envío de tu compra, ¡y listo!'
				),
			},
			{
				header: _vm.$lang('¿Cuánto tardan en enviar mi libro personalizado?'),
				content: _vm.$langText(
					'Queremos que estés tranquilo, ¡por eso siempre podrás hacer el seguimiento de tu orden! Solo recuerda que al ser un producto a pedido, una vez realizada la compra, el tiempo en el que la recibirás dependerá del domicilio que seleccionaste para la entrega: Para CABA-GBA y destinos fuera de Argentina, se entregará en un máximo de 12 días hábiles. Para el interior, en 15 días hábiles.\n\nSi prefieres retirarlo por nuestra sucursal, en un máximo de 8 días hábiles estará disponible.\n\nRecibirás notificaciones en tu casilla de correo electrónico con el estado de tu libro (recuerda siempre chequear la casilla de spam).'
				),
			},
			{
				header: _vm.$lang('¿Cómo realizan el envío?'),
				content: _vm.$langText(
					'Si estás en Argentina y seleccionas la opción envío a domicilio, despacharemos tu compra por Urbano. Si estás o envías tu compra a otro país, llegará a través de FedEx. Una vez que tu pedido sea enviado, recibirás un correo electrónico con los datos necesarios para que puedas realizar su seguimiento.'
				),
			},
			{
				header: _vm.$lang(
					'No he recibido ningún email de confirmación ¿quiere decir que mi compra no fue procesada?'
				),
				content: _vm.$langText(
					'Luego de recibir cada compra, enviamos un correo electrónico de confirmación con los datos de tu pedido. Sin embargo, en el caso de que no lo hayas recibido, te recomendamos revisar la bandeja de correo electrónico no deseado (también conocido como spam).\n\nSi efectivamente nuestro correo lo encontraste en la casilla de correo no deseado, recuerda marcarnos como correo electrónico válido, de esta forma nuestras notificaciones aparecerán en tu bandeja principal.\n\nSi ocurriera que no estamos tampoco como correo no deseado, te recomendamos buscar en la pestaña de Promociones.\n\nSi luego de verificar todas estas instancias previas continúas sin tener nuestro correo electrónico, por favor escríbenos a nuestro WhatsApp (+5491127612538) o Correo electrónico (plickme@oneminetta.com). En Plickme siempre habrá una persona para ayudarte.'
				),
			},
			{
				header: _vm.$lang('Tengo un cupón de descuento ¿dónde lo valido?'),
				content: _vm.$langText(
					'Para obtener tu beneficio, debes introducir tu código de cupón en el campo Cupón de descuento en el módulo Aplica descuento. El mismo aparecerá en tu pantalla luego de que tengas tus productos en el carrito y presiones: finalizar compra.'
				),
			},
			{
				header: _vm.$lang('¡Me equivoqué en los datos! ¿Puedo modificar mi pedido?'),
				content: _vm.$langText(
					'Una vez que termines de personalizar tus libros, te aparecerá la pantalla del carrito. Ahí verás todos tus productos y en cada uno, un botón que dice editar. Haciendo click allí, puedes ir nuevamente a tu pedido y hacer las modificaciones que desees.\n\nUna vez que hayas realizado el pago de tu compra, no tendrás la posibilidad de hacer cambios, por eso te recomendamos revisar detenidamente tu orden antes de terminar tu compra.'
				),
			},
			{
				header: _vm.$lang('¿Para qué edades son los libros de Plickme?'),
				content: _vm.$langText(
					'La mayoría de nuestros libros están recomendados para niños de entre 0 y 8 años, pero también podrás encontrar títulos para mayores de 15 años.\n\nSi quieres saber la edad recomendada de alguno en específico, te recomendamos ir a la descripción del mismo y conocer las especificaciones.'
				),
			},
			{
				header: _vm.$lang('¿En qué idioma puedo personalizar los libros de Plickme?'),
				content: _vm.$langText('Nuestros libros están disponibles en español, inglés y portugués.'),
			},
			{
				header: _vm.$lang('¿Puedo ver cómo es mi libro antes de encargarlo?'),
				content: _vm.$langText(
					'Luego de seleccionar el libro que quieres, puedes previsualizarlo online y ver por adelantado, cómo la historia cobra vida con el nombre de tu peque antes de finalizar tu compra.'
				),
			} ],"content-class":"my-4","panel-class":"py-2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }